/**
 * ExportButtonsPlaceholder - Disabled Export Buttons
 * 
 * Zeigt deaktivierte CSV/Excel Export-Buttons als Platzhalter
 * für zukünftige Export-Funktionalität.
 */

import { FileText, FileSpreadsheet } from 'lucide-react';
import { Tooltip } from './Tooltip';

interface ExportButtonsPlaceholderProps {
  /** Zeige nur Excel-Button (wenn CSV bereits existiert) */
  excelOnly?: boolean;
  /** Zeige nur CSV-Button */
  csvOnly?: boolean;
  /** Zusätzliche CSS-Klassen für den Container */
  className?: string;
}

/**
 * Disabled Export Buttons - Feature in Vorbereitung
 */
export function ExportButtonsPlaceholder({
  excelOnly = false,
  csvOnly = false,
  className = '',
}: ExportButtonsPlaceholderProps) {
  const showCsv = !excelOnly;
  const showExcel = !csvOnly;

  // Disabled-Styling: gleiche Farben wie aktive Buttons, aber mit opacity-50
  // Excel: Grün (wie bestehende Export-Buttons)
  // CSV: Blau (Kontrast zu Excel)
  return (
    <div className={`flex gap-2 ${className}`}>
      {showExcel && (
        <Tooltip content="In Vorbereitung – Export ist noch nicht verfügbar">
          <button
            type="button"
            disabled
            aria-disabled="true"
            className="inline-flex items-center px-3 py-2 bg-green-600 text-white rounded-lg text-sm font-medium opacity-50 cursor-not-allowed gap-2"
          >
            <FileSpreadsheet className="w-4 h-4" />
            <span className="hidden sm:inline">Excel</span>
          </button>
        </Tooltip>
      )}
      {showCsv && (
        <Tooltip content="In Vorbereitung – Export ist noch nicht verfügbar">
          <button
            type="button"
            disabled
            aria-disabled="true"
            className="inline-flex items-center px-3 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium opacity-50 cursor-not-allowed gap-2"
          >
            <FileText className="w-4 h-4" />
            <span className="hidden sm:inline">CSV</span>
          </button>
        </Tooltip>
      )}
    </div>
  );
}
